import axios from './axios';

export interface InvitationDetail {
  id: string;
  email: string;
  name?: string;
  invitation_type: string;
  role: string;
  related_project_id?: string;
  status: string;
  expires_at?: string;
  user_exists?: boolean;
  is_tim_pelaksana?: boolean;
  project_name?: string;
  inviter_name?: string;
  inviter_company?: string;
}

export const verifyInvitationToken = async (token: string) => {
  const res = await axios.get(`/v1/invitations/${token}/verify`);
  return res.data?.content as InvitationDetail;
};

export const acceptInvitationToken = async (token: string, password?: string) => {
  const res = await axios.post(`/v1/invitations/${token}/accept`, { password });
  return res.data?.content;
};
